import React from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Home from "./pages/Home"
import Login from "./pages/Login"
import Register from "./pages/Register"
import Marketplace from "./pages/Marketplace"
import MarketplaceCategories from "./pages/Marketplace/MarketplaceCategories"
import MarketplaceItemDetails from "./pages/Marketplace/MarketplaceItemDetails"
import MarketplaceCreateListing from "./pages/Marketplace/MarketplaceCreateListing"
import UserProfile from "./pages/UserProfile"
import Offers from "./pages/Offers"
import Cart from "./pages/Cart"
import MarketplaceChat from "./pages/Marketplace/MarketplaceChat"
import Faq from "./pages/Faq"
import Contact from "./pages/Contact"
import Tickets from "./pages/Tickets"
import Navigator from "./components/commons/Navigator"
import { AuthProvider } from './context/authContext'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import PrivateRoute from "./components/PrivateRoute"
import PaymentSettings from "./pages/PaymentSettings"
import MyListingsPage from "./pages/MyListingsPage"
import BlockedSellersPage from "./pages/BlockedSellersPage"
import Layout from "./components/Layout"
import RatingAndReviews from "./sections/user-profile/RatingAndReviews"
import SidebarChat from "./components/sidebars/SidebarChat"
import SidebarIndividualChat from "./components/sidebars/SidebarIndividualChat"
import MarketplaceEditListing from "./pages/Marketplace/MarketplacceEditListing"
import SidebarCart from "./components/sidebars/SidebarCart"
import Plans from "./pages/plans";
import PaymentSuccess from "./pages/PaymentSuccess";
import PublicProfile from "./pages/PublicProfile"
import Shopify from "./pages/Shopify"
import ShopifyProductDetails from "./pages/ShopifyProductDetails"
import ShopifyListingsPage from "./pages/ShopifyListingsPage"
import CookieConsent from "react-cookie-consent";
import PrivacyPolicy from "./pages/PrivacyPolicy"
import UserAgreement from "./pages/UserAgreement"
import ReturnPolicy from "./pages/ReturnPolicy"
import CookiePolicy from "./pages/CookiePolicy"
import RemoteGuard from "./components/RemoteGuard";
import Broken from "./pages/Broken";

function App() {
  return (
    <AuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
        style={{ zIndex: 10000000 }}
      />

      <CookieConsent
        enableDeclineButton
        buttonText="accept"
        declineButtonText="deny"
        onDecline={() => {
          console.log("cookie nay!");
        }}
        buttonClasses="uppercase text-[#242424] font-montech font-bold text-[10.5px] hover:opacity-75 !bg-primary !border-[1px] !border-solid !border !border-[#C3C3C3] !m-0 !rounded-[3.15px] w-[97px] md:w-[158px] !p-2"
        declineButtonClasses="uppercase text-white font-montech font-bold text-[10.5px] !bg-[#3B3B3B] hover:opacity-75 !border !border-solid !border-[#C3C3C3] !m-0 order-last !rounded-[3.15px] w-[97px] md:w-[158px] !p-2"
        buttonWrapperClasses="flex flex-row md:flex-col gap-2"
        contentClasses="!m-0 !flex-1"
        containerClasses="!bg-[#1A1A1A] !border !border-[#c3c3c3] !rounded-[3.15px] items-center max-w-[856px] p-5 gap-5 flex flex-col md:flex-row !items-center !left-1/2 -translate-x-1/2 !bottom-4"
      >
        <div className="flex flex-col md:flex-row items-center gap-5">
          <img
            src="/assets/icons/cookie.svg"
            className="w-[45px] h-[38.25px] md:w-[59.87px] md:h-[50.89px]"
            alt=""
          />
          <div className="font-montech text-white text-[12px] md:text-[14.6px] capitalize">
            cardshopexchange uses cookies to improve user experience and site performance, offer content tailored to your interests and enable social media sharing. By clicking "Accept" or continuing to use our site, you agree to our use of cookies.
          </div>
        </div>
      </CookieConsent>

      <SidebarChat />

      <Router>
        {/* <Navigator /> */}
        <RemoteGuard>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/user-agreement" element={<UserAgreement />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/broken" element={<Broken />} />
          <Route path="/shopify" element={<Shopify />} />
          <Route path="/shopify/:productId" element={<PrivateRoute element={<ShopifyProductDetails />} />} />

          <Route
            path="/marketplace/categories"
            element={<MarketplaceCategories />}
          />
          <Route
            path="/marketplace/:cardId"
            element={<PrivateRoute element={<MarketplaceItemDetails />} />}
          />

          <Route path="/my-profile" element={<PrivateRoute element={<UserProfile />} />} />

          <Route
            path="/success"
            element={<PrivateRoute element={<PaymentSuccess />} />}
          />
          
          <Route
            path="/user-profile/:userId"
            element={<PrivateRoute element={<PublicProfile />} />}
          />

          <Route path="/faqs" element={<PrivateRoute element={<Faq />} />} />
          <Route path="/support" element={<PrivateRoute element={<Contact />} />} />
          <Route path="/offers" element={<PrivateRoute element={<Offers />} />} />
          <Route path="/ratings" element={<PrivateRoute element={<RatingAndReviews />} />} />
          <Route path="/my-listings" element={<PrivateRoute element={<MyListingsPage />} />} />
          <Route path="/shopify-listings" element={<PrivateRoute element={<ShopifyListingsPage />} />} />

          <Route path="/blocked-sellers" element={<PrivateRoute element={<BlockedSellersPage />} />} />

          <Route path="/payment-settings" element={<PrivateRoute element={<PaymentSettings />} />} />
          <Route path="/purchase-sale" element={<PrivateRoute element={<Cart />} />} />

          <Route
            path="/marketplace/create-listing"
            element={<PrivateRoute requireMembership element={<MarketplaceCreateListing />} />}
          />
          <Route
            path="/marketplace/edit-listing/:cardId"
            element={<PrivateRoute requireMembership element={<MarketplaceEditListing />} />}
          />
          <Route path={`/marketplace/chat/:recipientId`} element={<PrivateRoute element={<MarketplaceChat />} />} />
        </Routes>
        </RemoteGuard>
      </Router>
    </AuthProvider>
  )
}

export default App
